import { useLocaleContext } from './LocaleProvider.js';
import type { Messages, Namespace } from './types.js';

function resolve(messages: Messages, path: string): string | undefined {
    const parts = path.split('.');
    let current: Messages | string = messages;

    for (const part of parts) {
        if (typeof current === 'string' || current[part] === undefined) {
            return undefined;
        }

        current = current[part];
    }

    return typeof current === 'string' ? current : undefined;
}

function interpolate(template: string, values: Record<string, string | number>): string {
    return template.replace(/\{(\w+)\}/g, (_, key: string) => String(values[key] ?? `{${key}}`));
}

export function useTranslations(namespace: Namespace) {
    const { dictionary, locale } = useLocaleContext();
    const messages = dictionary[namespace];

    function t(key: string, values?: Record<string, string | number>): string {
        const value = resolve(messages, key);

        if (value === undefined) {
            return key;
        }

        return values ? interpolate(value, values) : value;
    }

    return { t, locale };
}
